// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1 ? "93b25bb5" : chunkId) + "." + {"1":"9eb5e72fd63438be","225":"4adaa1b5c3fe4897","616":"c1c330a4c21da76d","760":"55b0a9a5854b5601"}[chunkId] + ".js";
};